import React from "react";
import "./Ambitiousfuture.css";
import crystalball from "../../Media/crystalball.svg";

const Ambitiousfuture = () => {
  return (
    <div className="building-ambitious-future">
      <div className="building-ambitious-future-content-one">
        <h2 className="building-ambitious-future-content-one-text">
          Building Ambitious Future
        </h2>
      </div>
      <div className="building-ambitious-future-content-two">
        <p className="building-ambitious-future-content-two-text">
          Through Innovation and collective knowledge Althi Solutions is an IT
          services, consulting, and business solutions organization. We serve
          both big and small businesses in various industries such as
          manufacturing, healthcare, finance, education, etc.
        </p>
      </div>
      <div className="building-ambitious-future-content-three">
        <img
          className="building-ambitious-future-content-three-image"
          src={crystalball}
          alt="Illustration representing future innovation and vision"
        />
      </div>
    </div>
  );
};

export default Ambitiousfuture;
